

import { Alert, Box, Button, Card, CircularProgress, Container, Divider, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Radio, RadioGroup, Snackbar, TextField, Typography } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { authActions } from "../../store/reducer/auth-reducer";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import AlertBar from "../../components/AlertBar";
import bankdetails from "../profile/bankdetails";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import dayjs, { Dayjs } from 'dayjs';
import { homePageActions } from "../../store/reducer/home";
var isSameOrAfter = require("dayjs/plugin/isSameOrAfter");

const defLogin: any = { app_key: "@34Y@#8deepmatka", gpay: '', phonepe: '', paytm: '' }
const defaultInputFields = {
    points: { label: 'Add Points', input: 'text', value: '', placeholder: 'Enter your points' },
    amount: { label: 'Add Points', input: 'text', value: [] }
}

const WithdrawPoints = ({ isLoginLoading, bankData, isGetBankFailed, pageMessage, isGetBankSuccess, isAddPopintsSuccess, isAddPopintsFailed, wdData, withdrawSuccess, withdrawFailed, }: any) => {
    const userDataSession: any = localStorage.getItem('userData');
    const finalData = JSON.parse(userDataSession)
    const outletData: any = useOutletContext();
    // const newDate = dayjs();
    // var today = new Date();
    // var dd = String(today.getDate()).padStart(2, '0');
    // var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    // var yyyy = today.getFullYear();
    // const todayDate = mm + '/' + dd + '/' + yyyy;
    // console.log(new Date(todayDate + newDate.format('hh:mm A')).getHours())

    dayjs.extend(isSameOrAfter)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState<any>({ status: false, message: '', severity: '', inputName: '' })
    const [pointsData, setPointsData] = useState<any>({ point: '', payfrom: '' })
    const [bankDataList, setBankDataList] = useState<any>({
        "bank_detail_id": "",
        "user_id": "",
        "bank_name": "",
        "branch_address": "",
        "ac_holder_name": "",
        "ac_number": "",
        "ifsc_code": "",
        "paytm_number": "",
        "google_pay_number": "",
        "phone_pay_number": "",
        "insert_date": ""
    })

    const [withdrawData, setWDData] = useState<any>({
        "withdraw_open_time": "",
        "withdraw_close_time": "",
        "withdrawdata": [],
        "last_request_status": "",
        "msg": "",
        "status": true,
        "wallet_amt": ""
    })


    useEffect(() => {
        const data: any = {
            user_id: finalData.user_id,
            app_key: "@34Y@#8deepmatka",
        }
        // Fetch both bank details and withdraw data immediately
        dispatch(authActions.getBankDetailsReq(data))
        dispatch(authActions.getWDReq(data))

        const pay: any = {
            menuname: 'withdraw'
        }
        dispatch(homePageActions.selectedMenu(pay))

    }, [])

    useEffect(() => {
        if (bankData && bankData.length > 0) {
            setBankDataList(bankData[0])
        }
    }, [bankData])

    useEffect(() => {
        if (process.env.NODE_ENV === 'development') {
            console.log('wdData received:', wdData);
        }
        if (wdData && Object.keys(wdData).length > 0) {
            const updatedData = {
                withdraw_open_time: wdData.withdraw_open_time || '',
                withdraw_close_time: wdData.withdraw_close_time || '',
                withdrawdata: wdData.withdrawdata || [],
                last_request_status: wdData.last_request_status || '',
                msg: wdData.msg || '',
                status: wdData.status !== undefined ? wdData.status : true,
                wallet_amt: wdData.wallet_amt || ''
            }
            if (process.env.NODE_ENV === 'development') {
                console.log('Setting withdrawData:', updatedData);
            }
            setWDData(updatedData)
        }
    }, [wdData])

    const handleOnChange = (event: any) => {
        setPointsData((prev: any) => {
            return { ...prev, [event.target.name]: event.target.value }
        })
    }

    const handleRadioChange = (event: any) => {
        setPointsData((prev: any) => {
            return { ...prev, payfrom: event.target.value }
        })
    }

    function checkTime() {
        if (!withdrawData.withdraw_open_time || !withdrawData.withdraw_close_time) {
            return false;
        }

        try {
            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0');
            var yyyy = today.getFullYear();
            var todayDate = yyyy + '-' + mm + '-' + dd;

            // Parse time strings (format: "hh:mm A" or "HH:mm")
            const openTimeStr = withdrawData.withdraw_open_time;
            const closeTimeStr = withdrawData.withdraw_close_time;

            // Convert 12-hour format to 24-hour format if needed
            const parseTime = (timeStr: string) => {
                if (timeStr.includes('AM') || timeStr.includes('PM')) {
                    // 12-hour format
                    const [timePart, period] = timeStr.split(' ');
                    const [hours, minutes] = timePart.split(':');
                    let hour24 = parseInt(hours);
                    if (period === 'PM' && hour24 !== 12) hour24 += 12;
                    if (period === 'AM' && hour24 === 12) hour24 = 0;
                    return { hours: hour24, minutes: parseInt(minutes) };
                } else {
                    // 24-hour format
                    const [hours, minutes] = timeStr.split(':');
                    return { hours: parseInt(hours), minutes: parseInt(minutes) };
                }
            };

            const openTime = parseTime(openTimeStr);
            const closeTime = parseTime(closeTimeStr);

            var currentD = today;
            var startTime = new Date();
            startTime.setHours(openTime.hours, openTime.minutes, 0, 0);
            var endTime = new Date();
            endTime.setHours(closeTime.hours, closeTime.minutes, 0, 0);

            // Handle case where end time is next day (e.g., 10 PM to 2 AM)
            if (endTime <= startTime) {
                endTime.setDate(endTime.getDate() + 1);
            }

            if (currentD >= startTime && currentD < endTime) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error checking time:', error);
            return false;
        }
    }

    const updatePoints = (event: any) => {
        event.stopPropagation();
        event.preventDefault();

        // Validate time first
        if (!withdrawData.withdraw_open_time || !withdrawData.withdraw_close_time) {
            setErrorMessage({ status: true, message: "Withdrawal time information is not available. Please try again later.", severity: 'warning', inputName: '' })
            return;
        }

        if (!checkTime()) {
            setErrorMessage({ status: true, message: `Withdrawal is only available between ${withdrawData.withdraw_open_time} and ${withdrawData.withdraw_close_time}.`, severity: 'warning', inputName: 'point' })
            return;
        }

        // Validate points input
        if (!pointsData.point || pointsData.point.trim().length === 0) {
            setErrorMessage({ status: true, message: "Please enter valid points.", severity: 'warning', inputName: 'point' })
            return;
        }

        // Validate payment method
        if (pointsData.payfrom === '') {
            setErrorMessage({ status: true, message: "Please select payment method", severity: 'warning', inputName: '' })
            return;
        }

        // Validate amount
        const pointValue = parseInt(pointsData.point);
        if (isNaN(pointValue) || pointValue <= 0) {
            setErrorMessage({ status: true, message: "Please enter a valid amount.", severity: 'warning', inputName: 'point' })
            return;
        }

        // Check wallet balance limits
        if (outletData.walletBalance && outletData.walletBalance.min_withdrawal) {
            if (pointValue < parseInt(outletData.walletBalance.min_withdrawal)) {
                setErrorMessage({ status: true, message: `Minimum withdrawal amount is ${outletData.walletBalance.min_withdrawal}.`, severity: 'warning', inputName: 'point' })
                return;
            }
        }

        if (outletData.walletBalance && outletData.walletBalance.max_withdrawal) {
            if (pointValue > parseInt(outletData.walletBalance.max_withdrawal)) {
                setErrorMessage({ status: true, message: `Maximum withdrawal amount is ${outletData.walletBalance.max_withdrawal}.`, severity: 'warning', inputName: 'point' })
                return;
            }
        }

        // Check wallet balance
        if (outletData.walletBalance && outletData.walletBalance.wallet_balance) {
            if (pointValue > parseFloat(outletData.walletBalance.wallet_balance)) {
                setErrorMessage({ status: true, message: "Insufficient wallet balance.", severity: 'warning', inputName: 'point' })
                return;
            }
        }

        // All validations passed, proceed with withdrawal
        const payload: any = {
            app_key: "@34Y@#8deepmatka",
            user_id: finalData.user_id,
            request_amount: pointValue.toString(),
            payment_method: (pointsData.payfrom === 'gpay') ? 3 : (pointsData.payfrom === 'phonepe') ? 4 : (pointsData.payfrom === 'paytm') ? 2 : 1
        }

        setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
        setPointsData({ point: '', payfrom: '' });
        dispatch(authActions.withdrawReq(payload))
    }


    useEffect(() => {

        if (withdrawSuccess) {
            setErrorMessage({ status: true, message: pageMessage, severity: 'success', inputName: '' })
            const data: any = { "app_key": "@34Y@#8deepmatka", "user_id": finalData.user_id }
            dispatch(authActions.getWalletBalanceReq(data))
            dispatch(authActions.getWDReq(data))
            // Reset form after successful withdrawal
            setPointsData({ point: '', payfrom: '' });
        }

        if (isGetBankFailed) {
            setErrorMessage({ status: true, message: pageMessage, severity: 'warning', inputName: '' })
        }

        if (withdrawFailed) {
            setErrorMessage({ status: true, message: pageMessage, severity: 'warning', inputName: '' })
        }

        return (() => {
            dispatch(authActions.resetLoginState());
        })
    }, [withdrawSuccess, withdrawFailed, isGetBankFailed])



    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
    };
    
    // Debug logs - remove in production
    if (process.env.NODE_ENV === 'development') {
        console.log('bankDataList:', bankDataList);
        console.log('wdData from props:', wdData);
        console.log('withdrawData state:', withdrawData);
        console.log('checkTime result:', checkTime());
    }
    return (
        <Container>
            <Grid container>
                <AlertBar handleClose={handleClose} errorMessage={errorMessage} />

                <Grid xs={12} lg={12} md={12} sm={12} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: '0px' }}>
                    <Card sx={{ display: 'flex', border:'none', boxShadow: '0px 0px 2px #adadad27', flexDirection: 'column', alignItems: "center", justifyContent: 'center', gap: 2, padding: '20px 20px 20px 20px' }}>
                        <Box sx={{ width: '100%', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '8px', marginBottom: '10px' }}>
                            {isLoginLoading && !withdrawData.withdraw_open_time ? (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <CircularProgress size={16} />
                                    <Typography sx={{ fontSize: '0.9rem', color: '#666' }}>Loading withdrawal times...</Typography>
                                </Box>
                            ) : (
                                <>
                                    <Typography sx={{ fontSize: '0.9rem', fontWeight: 'bold', color: '#333', marginBottom: '5px' }}>
                                        Withdraw Open Time : {withdrawData.withdraw_open_time || 'Not Available'}
                                    </Typography>
                                    <Typography sx={{ fontSize: '0.9rem', fontWeight: 'bold', color: '#333' }}>
                                        Withdraw Close Time : {withdrawData.withdraw_close_time || 'Not Available'}
                                    </Typography>
                                    {withdrawData.withdraw_open_time && withdrawData.withdraw_close_time && (
                                        <Typography sx={{ fontSize: '0.8rem', color: checkTime() ? '#4caf50' : '#f44336', marginTop: '5px', fontWeight: 'bold' }}>
                                            Status: {checkTime() ? 'Withdrawal Available Now' : 'Withdrawal Not Available - Please check the time'}
                                        </Typography>
                                    )}
                                    {!withdrawData.withdraw_open_time && !isLoginLoading && (
                                        <Typography sx={{ fontSize: '0.8rem', color: '#f44336', marginTop: '5px' }}>
                                            Unable to load withdrawal times. Please refresh the page.
                                        </Typography>
                                    )}
                                </>
                            )}
                        </Box>



                        <FormControl sx={{ display: 'flex', width: '100%', fontSize:'0.9rem' }}>
                            <FormLabel sx={{ marginBottom: '5px',color:'#f7ae2b' }}>Points</FormLabel>
                            <TextField sx={{ width: "100%" ,'.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { border: '1px solid #f7ae2b' }}} placeholder="Enter points to withdraw" name="point" variant="outlined" value={pointsData.point} type="text"
                                error={(errorMessage.inputName === 'point') ? errorMessage.status ? errorMessage.message : '' : ''} helperText={(errorMessage.inputName === 'point') ? errorMessage.status ? errorMessage.message : '' : ''}
                                onChange={handleOnChange} />
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                            >
                                {bankDataList.google_pay_number && <FormControlLabel sx={{color:'#f7ae2b', marginRight:'8px'}} value={'gpay'} control={<Radio checked={pointsData.payfrom === 'gpay'} onChange={handleRadioChange} />} label={'GPay'} />}
                                {bankDataList.phone_pay_number && <FormControlLabel sx={{color:'#f7ae2b', marginRight:'8px'}}  value={'phonepe'} control={<Radio checked={pointsData.payfrom === 'phonepe'} onChange={handleRadioChange} />} label={'PhonePe'} />}
                                {bankDataList.ac_number && <FormControlLabel sx={{color:'#f7ae2b', marginRight:'8px'}}  value={'bankaccount'} control={<Radio checked={pointsData.payfrom === 'bankaccount'} onChange={handleRadioChange} />} label={'Bank Account'} />}

                            </RadioGroup>

                        </FormControl>





                        <Button 
                            variant="contained" 
                            sx={{
                                width:"100%",
                                boxShadow: '0px 0px 2px #adadad27', 
                                backgroundColor: (!withdrawData.withdraw_open_time || !withdrawData.withdraw_close_time || !checkTime() || isLoginLoading) ? '#cccccc' : '#f7ae2b', 
                                ':hover':{backgroundColor: (!withdrawData.withdraw_open_time || !withdrawData.withdraw_close_time || !checkTime() || isLoginLoading) ? '#cccccc' : '#f7ae2b'},
                                marginTop: '10px',
                                color: (!withdrawData.withdraw_open_time || !withdrawData.withdraw_close_time || !checkTime() || isLoginLoading) ? '#666' : '#fff'
                            }}  
                            color="primary" 
                            onClick={(event: any) => updatePoints(event)}
                            disabled={!withdrawData.withdraw_open_time || !withdrawData.withdraw_close_time || !checkTime() || isLoginLoading}
                        >
                            {isLoginLoading ? 'Processing...' : (!withdrawData.withdraw_open_time || !withdrawData.withdraw_close_time ? 'Loading...' : 'Submit Withdrawal Request')}
                        </Button>
                        {isLoginLoading ? <div style={{ width: '100%', height: '30vh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}> <CircularProgress /> </div> :
                            withdrawData.withdrawdata ?
                                <>
                                    <List sx={{ width: '100%',height:'calc(100vh - 500px)', overflowY: 'scroll', overflowX: 'none' }}>
                                        {withdrawData.withdrawdata.map((item: any, index: number) => (
                                            <>
                                                <ListItem disablePadding>
                                                    <ListItemButton sx={{ padding: 0 }}>
                                                        <ListItemText sx={{ padding: 0 }}>
                                                            <Grid container>
                                                                <Grid lg={10} sx={{ textTransform: 'capitalize' }}>
                                                                    <Typography sx={{ fontSize: '0.8rem' }}><b>Request Amount : </b>{item.request_amount}</Typography>
                                                                    <Typography sx={{ fontSize: '0.8rem' }}><b>Request Number  : </b>{item.request_number}</Typography>
                                                                    {item.insert_date && <Typography sx={{ fontSize: '0.8rem', color: '#666' }}><b>Date & Time : </b>{item.insert_date}</Typography>}
                                                                    <Typography sx={{ fontSize: '0.8rem' }}><b>Transferred On </b>{item.payment_method === "3" ? 'Google Pay : ' + item.google_pay_number : item.payment_method === "4" ? 'Phone Pe : ' + item.phone_pay_number : 'Bank Account : ' + item.ac_number}</Typography>
                                                                    {item.request_status == '2' ? <Typography sx={{ fontSize: '0.8rem', color: '#4caf50' }}><b>Withdraw Success :</b> <a href={item.payment_receipt} target='_blank' rel="noopener noreferrer"><b>Check Reciept</b></a></Typography> : <Typography sx={{ fontSize: '0.8rem', color: '#ff9800' }}><b>Withdraw Pending</b> </Typography>}
                                                                    {item.request_status == '2' && item.remark && <Typography sx={{ fontSize: '0.8rem' }}><b>Remark  :</b> {item.remark}</Typography>}
                                                                </Grid>

                                                            </Grid>
                                                        </ListItemText>
                                                    </ListItemButton>
                                                </ListItem>
                                                <Divider />
                                            </>
                                        ))}
                                    </List>

                                </> : ''}
                    </Card>
                </Grid>
            </Grid>
        </Container>
    )
}



const mapStateToProps = (state: any) => ({
    isLoginLoading: state.authentication.isLoginLoading,
    isGetBankSuccess: state.authentication.isGetBankSuccess,
    isGetBankFailed: state.authentication.isGetBankFailed,
    pageMessage: state.authentication.pageMessage,
    bankData: state.authentication.bankData,
    isAddPopintsSuccess: state.authentication.isAddPopintsSuccess,
    isAddPopintsFailed: state.authentication.isAddPopintsFailed,
    wdData: state.authentication.wdData,
    withdrawSuccess: state.authentication.withdrawSuccess,
    withdrawFailed: state.authentication.withdrawFailed,


})


export default connect(mapStateToProps)(WithdrawPoints);
